export default __webpack_public_path__ + "static/bg-2-99d6f7127c9cd2c42c18b388dcf439c9.jpg";